// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-details {
  padding: 10px 0;
  margin-bottom: 1rem;
}

.license-details-table {
  table-layout: auto;
  max-width: fit-content;
}

.license-details-row {
  height: 30px;
}

.license-details-cell{
  padding: 3px 20px;
  text-align: center;
}

.license-details-cell:not(:first-child) {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}

.low-usage-left-row {
  background-color: #ffbd80cb;
}
.extreme-low-usage-left-row {
  background-color: #ff8080cb;
}

.expiration-data {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}

.expiration-date {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/license/license-manage/license-details/LicenseDetails.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".license-details {\r\n  padding: 10px 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.license-details-table {\r\n  table-layout: auto;\r\n  max-width: fit-content;\r\n}\r\n\r\n.license-details-row {\r\n  height: 30px;\r\n}\r\n\r\n.license-details-cell{\r\n  padding: 3px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.license-details-cell:not(:first-child) {\r\n  border-left: 1px solid rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.low-usage-left-row {\r\n  background-color: #ffbd80cb;\r\n}\r\n.extreme-low-usage-left-row {\r\n  background-color: #ff8080cb;\r\n}\r\n\r\n.expiration-data {\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: row;\r\n  align-items: flex-end;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.expiration-date {\r\n  font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
